import type { ErrorRegistryShape } from '../common/common.error';

export const SCHEDULED_MAIL_ERROR = {
  NOT_FOUND_MAIL_KIND: { status: 404, message: 'Mail kind not found' },
  /** 그 종류가 지원하지 않는 목적(LP 분기 보고의 리마인드 등) */
  BAD_REQUEST_MAIL_PURPOSE: { status: 400, message: 'Purpose not supported by this kind' },
  /** 미리보기 · 테스트에 쓸 대상이 없음 */
  CONFLICT_MAIL_NO_TARGET: { status: 409, message: 'No target for this mail' },
  /** 미리보기 · 테스트 — 지정한 대상(targetId)이 그 종류의 대상 목록에 없음(삭제된 포트폴리오 · LP 등) */
  NOT_FOUND_MAIL_TARGET: { status: 404, message: 'Mail target not found' },
  /** 테스트 발송 — 요청자 이메일 없음 */
  CONFLICT_MAIL_NO_EMAIL: { status: 409, message: 'Requester has no email' },
  NOT_FOUND_MAIL_HISTORY: { status: 404, message: 'Mail history not found' },
  /** 취소는 예약, 재발송은 실패 · 취소 이력만 */
  CONFLICT_MAIL_HISTORY_STATUS: { status: 409, message: 'Mail history status does not allow this' },
  /** 재발송 — 종류 · 목적 · 연도 · 분기가 비어 있는 이력(기존 v2 이력 등)은 같은 내용으로 다시 만들 수 없음 */
  CONFLICT_MAIL_HISTORY_INCOMPLETE: {
    status: 409,
    message: 'Mail history lacks kind, purpose or quarter',
  },
} as const satisfies ErrorRegistryShape;
